import {Component,Inject} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {ResultatCalculFinal} from "@domain/ndf/resultat-calcul-final";
import {ImputationAvanceCalculFinal} from "@domain/ndf/imputation-avance-calcul-final";
import {DeviseMontant,ModeImputation} from "@domain/ndf/calcul-final";

/**
 * Popin d'affichage du résultat du calcul final des avances à imputer
 *
 * @author Laurent Convert
 * @date 24/04/2026
 */
@Component({
	host: {'data-test-id': 'resultat-calcul-final'},
	selector: 'resultat-calcul-final',
	templateUrl: './resultat-calcul-final.component.html'
})
export class ResultatCalculFinalComponent {
	/** Déclaration pour accès dans le template */
	ModeImputation = ModeImputation;

	/** Liste des imputations par devise (extraite de la map) */
	listeImputations: ImputationAvanceCalculFinal[] = [];

	/** Imputations hors "OTHERS" pour le mode 3 */
	listeImputationsDevise: ImputationAvanceCalculFinal[] = [];

	/** Imputation "OTHERS" regroupant les devises étrangères (mode 3) */
	imputationOthers?: ImputationAvanceCalculFinal;

	/** Indicateur d'ouverture du détail "Autres devises" (mode 3) */
	isOthersDetailOpen: boolean = false;

	/** Indicateur d'ouverture du détail "Total dépenses" (mode 4) */
	isDepensesDetailOpen: boolean = false;

	/** Map des montants des dépense par devise */
	mapDeviseMontant: Map<string,DeviseMontant> = new Map();

	/**
	 * Constructeur
	 *
	 * @param data Données en entrée de la popin
	 * @param dialogRef Référence de la boîte de dialogue
	 */
	constructor(@Inject(MAT_DIALOG_DATA) public data: ResultatCalculFinal,
				private dialogRef: MatDialogRef<ResultatCalculFinalComponent,boolean>) {
		//Extraction des imputations par devise depuis l'objet map
		if (this.data.calculFinal?.imputationAvances) {
			this.listeImputations = Object.values(this.data.calculFinal.imputationAvances);

			//Séparation des imputations pour le mode 3 (solde devise)
			this.listeImputationsDevise = this.listeImputations.filter(i => i.devise !== 'OTHERS');
			this.imputationOthers = this.listeImputations.find(i => i.devise === 'OTHERS');
		}

		for (const dm of data.calculFinal.listeDeviseMontant) {
			this.mapDeviseMontant.set(dm.devise,dm);
		}
	}

	/**
	 * Valide le calcul final
	 */
	valider() {
		this.dialogRef.close(true);
	}

	/**
	 * Bascule l'affichage du détail des devises étrangères (OTHERS)
	 */
	toggleOthersDetail() {
		this.isOthersDetailOpen = !this.isOthersDetailOpen;
	}

	/**
	 * Bascule l'affichage du détail des dépenses par devise (mode 4)
	 */
	toggleDepensesDetail() {
		this.isDepensesDetailOpen = !this.isDepensesDetailOpen;
	}

	/**
	 * Filtre les devises du détail "Autres devises" pour exclure celles déjà affichées
	 * dans les blocs principaux (listeImputationsDevise)
	 */
	getDevisesNonAffichees() {
		//Récupération des devises déjà affichées dans les blocs principaux
		const devisesAffichees = this.listeImputationsDevise.map(i => i.devise);

		//Filtrage de la liste des devises pour exclure celles déjà affichées
		return this.data.calculFinal.listeDeviseMontant?.filter(dm => !devisesAffichees.includes(dm.devise)) || [];
	}

}